import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

import type { ActionsReturnType, StorySharingHookProps } from './types';

// TODO: Finish implementation. Only tracking is implemented for now.
const TRACKING_EVENT_NAME = 'share_petition';
export function useFacebookStorySharing(props: StorySharingHookProps): ActionsReturnType {
	const track = useTracking();
	const {
		trackingProps: { context, viewContext },
	} = props;

	const primaryAction = useCallback(() => {
		void track(TRACKING_EVENT_NAME, {
			context,
			location: 'facebook_story',
			tab_at_share: viewContext,
			content: 'post',
			app_available: false,
		});
	}, [context, track, viewContext]);

	return {
		primaryAction,
		secondaryAction: undefined,
	};
}
